// Layout.js
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "./Dashboard/Sidebar/SideBar";
import Header from "./Dashboard/Header/Header";
import PolicyCar from "../Images/customer/policy-car.svg";
import PolicyBike from "../Images/customer/policy-bike.svg";
import PolicyInvestment from "../Images/customer/policy-investment.svg";
import PolicyHealth from "../Images/customer/policy-health.svg";
import PolicyLife from "../Images/customer/policy-life.svg";
import Home from "../Images/customer/home.webp";
import Pet from "../Images/customer/pet.webp";
import PI from "../Images/customer/Professional-Indemnity.webp";
import PCV from "../Images/customer/policy-pcv.webp";
import GCV from "../Images/customer/policy-gcv.webp";
import Taxi from "../Images/customer/policy-taxi.webp";


const Layout = () => {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        const checkScreenSize = () => {
            setIsVisible(window.innerWidth > 768);
        };

        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);

        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    {isVisible &&
                        <SideBar />
                    }
                    <div className="col-md-10">
                        <Header />
                        <div className="MainDashboard">
                            <div className="row">
                                <div className="col-md-9">
                                    <Outlet />
                                </div>
                                <div className="col-md-3">
                                    <div className="RightSideBar">
                                        <h3>Get New Policy</h3>
                                        <ul>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/motor-insurance/car-insurance">
                                                    <span>
                                                        <img src={PolicyCar} alt="" />
                                                    </span>{" "}
                                                    Car Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/motor-insurance/two-wheeler-insurance">
                                                    <span>
                                                        <img src={PolicyBike} alt="" />
                                                    </span>{" "}
                                                    Bike Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/commercial-vehicle-insurance/goods-carrying-vehicle-insurance">
                                                    <span>
                                                        <img src={GCV} alt="" />
                                                    </span>{" "}
                                                    GCV Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/commercial-vehicle-insurance/passenger-carrying-vehicle-insurance">
                                                    <span>
                                                        <img src={PCV} alt="" />
                                                    </span>{" "}
                                                    PCV Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/motor-insurance/car-insurance/taxi-insurance">
                                                    <span>
                                                        <img src={Taxi} alt="" />
                                                    </span>{" "}
                                                    Taxi Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/health">
                                                    <span>
                                                        <img src={PolicyHealth} alt="" />
                                                    </span>{" "}
                                                    Health Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/investment">
                                                    <span>
                                                        <img src={PolicyInvestment} alt="" />
                                                    </span>{" "}
                                                    Investment Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/Life">
                                                    <span>
                                                        <img src={PolicyLife} alt="" />
                                                    </span>{" "}
                                                    Life Insurance
                                                </a>
                                            </li>

                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/homeinsurance">
                                                    <span>
                                                        <img src={Home} alt="" />
                                                    </span>{" "}
                                                    Home Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/pet">
                                                    <span>
                                                        <img src={Pet} alt="" />
                                                    </span>{" "}
                                                    Pet Insurance
                                                </a>
                                            </li>
                                            <li className="">
                                                <a className="" target="_blank" href="https://www.smcinsurance.com/indemnity">
                                                    <span>
                                                        <img src={PI} alt="" />
                                                    </span>{" "}
                                                    Indemnity Insurance
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Layout;
